import { fmtDate, ftmPrice } from "../../extensions/utils";
import { getStatusColor } from "../../extensions/helper";
import { Card, Typography } from "antd";
import ClientAbonItem from "./client-abon-item";
import { useEffect } from "react";
const { Text } = Typography;

const ClientItemAbon = ({ item, expanded, setExpanded, onAbonsUpdate }) => {
  
  const handleHeaderClick = () => {
    setExpanded(!expanded);
  };

  const stopPropagation = (e) => {
    e.stopPropagation();
  };

  const borderColor = getStatusColor(item.status, item);

  return (
    <Card className="client-item-abon-card" style={{ borderLeft: `4px solid ${borderColor}` }} onClick={handleHeaderClick}>
      <div className="client-item-abon-card-name-debt-fields">
        <Text strong>{item.productName}</Text>
        <Text strong>Долг: {ftmPrice(item.debet)}</Text>
      </div>

      <div className="client-item-abon-card-sum-sale-num-fields">
        <Text># {item.id}</Text>
        <Text>Сумма: {ftmPrice(item.syma)}</Text>
        <Text>Продажа: {fmtDate(item.docDate)}</Text>
      </div>

      <div style={{ maxHeight: expanded ? 800 : 0, opacity: expanded ? 1 : 0 }} className="client-item-abon-expand">
        {expanded && (
          <div onClick={stopPropagation}>
            <ClientAbonItem id={item.id} status={item.status} abon={item} onAbonsUpdate={onAbonsUpdate}/>
          </div>
        )}
      </div>
    </Card>
  );
}

export default ClientItemAbon;